(function () {
  function waitForSwiper(cb) {
    if (typeof window.Swiper !== 'undefined') {
      cb();
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (typeof window.Swiper !== 'undefined') {
        clearInterval(timer);
        cb();
      } else if (tries > 40) {
        clearInterval(timer);
      }
    }, 50);
  }

  function initGallery(root) {
    var mainEl = root.querySelector('[data-vb-product-main]');
    var thumbsEl = root.querySelector('[data-vb-product-thumbs]');
    if (!mainEl || typeof window.Swiper === 'undefined') return;

    if (mainEl.swiper) {
      try { mainEl.swiper.destroy(true, true); } catch (e) {}
    }
    if (thumbsEl && thumbsEl.swiper) {
      try { thumbsEl.swiper.destroy(true, true); } catch (e) {}
    }

    var thumbsSwiper = null;
    if (thumbsEl) {
      thumbsSwiper = new window.Swiper(thumbsEl, {
        spaceBetween: 8,
        slidesPerView: 6,
        freeMode: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        breakpoints: {
          0: { spaceBetween: 6, slidesPerView: 6 },
          641: { spaceBetween: 8, slidesPerView: 6 }
        }
      });
    }

    var prevEl = root.querySelector('[data-vb-product-prev]');
    var nextEl = root.querySelector('[data-vb-product-next]');

    new window.Swiper(mainEl, {
      speed: 450,
      spaceBetween: 0,
      loop: false,
      grabCursor: true,
      resistanceRatio: 0.65,
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl
      },
      thumbs: thumbsSwiper
        ? {
            swiper: thumbsSwiper,
            autoScrollOffset: 1
          }
        : undefined,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      }
    });
  }

  function initBundles(root) {
    var bundles = Array.prototype.slice.call(root.querySelectorAll('[data-vb-product-bundle]'));
    var variantInput = root.querySelector('[data-vb-product-variant]');
    var qtyInput = root.querySelector('[data-vb-product-qty]');
    var savingEl = root.querySelector('[data-vb-product-saving]');
    var atcPriceEl = root.querySelector('[data-vb-product-atc-price]');

    function selectBundle(btn) {
      bundles.forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      if (variantInput) variantInput.value = btn.dataset.variantId || '';
      if (qtyInput) qtyInput.value = btn.dataset.qty || '1';
      if (savingEl) {
        if (btn.dataset.saving) {
          savingEl.innerHTML = '<span aria-hidden="true">➤</span> ' + btn.dataset.saving;
          savingEl.hidden = false;
        } else {
          savingEl.hidden = true;
          savingEl.textContent = '';
        }
      }
      if (atcPriceEl && btn.dataset.price) {
        atcPriceEl.textContent = btn.dataset.price;
      }
    }

    bundles.forEach(function (btn) {
      btn.addEventListener('click', function () { selectBundle(btn); });
    });

    var selected = root.querySelector('[data-vb-product-bundle].is-selected') || bundles[0];
    if (selected) selectBundle(selected);
  }

  function getProductRoot() {
    var form = document.querySelector('[data-vb-pdp-product] .vb-pdp-product__form[data-vb-product-add-gifts="true"]');
    if (form) return form.closest('[data-vb-pdp-product]');
    return document.querySelector('[data-vb-pdp-product]');
  }

  function getSelectedBundle(root) {
    if (!root) return null;
    return root.querySelector('[data-vb-product-bundle].is-selected') || root.querySelector('[data-vb-product-bundle]');
  }

  function getKachingDealSettings(root) {
    if (!root) return null;

    var kachingBundle = root.querySelector('kaching-bundle');
    var productId = kachingBundle && kachingBundle.getAttribute('product-id');
    var dealBlock = root.querySelector('kaching-bundles-block[deal-block-id]');
    var dealBlockId = dealBlock && dealBlock.getAttribute('deal-block-id');
    var selector = 'script.kaching-bundles-deal-block-settings';
    if (productId) selector += '[data-product-id="' + productId + '"]';

    var scripts = Array.prototype.slice.call(document.querySelectorAll(selector));
    if (!scripts.length) return null;

    for (var i = 0; i < scripts.length; i += 1) {
      try {
        var settings = JSON.parse(scripts[i].textContent);
        if (!dealBlockId || settings.id === dealBlockId) return settings;
      } catch (error) {}
    }

    return null;
  }

  function getSearchRoots(root) {
    var roots = [root];
    root.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot) roots.push(el.shadowRoot);
    });
    return roots;
  }

  function isSelectedKachingNode(node) {
    var current = node;
    var steps = 0;

    while (current && steps < 5) {
      var className = String(current.className || '');
      if (
        current.matches &&
        current.matches('[aria-checked="true"], [aria-selected="true"], [checked], .selected, .is-selected, .active')
      ) {
        return true;
      }
      if (className.indexOf('selected') !== -1 || className.indexOf('active') !== -1) return true;
      current = current.parentElement || current.parentNode;
      steps += 1;
    }

    return false;
  }

  function getSelectedKachingDeal(root, settings) {
    if (!root || !settings || !Array.isArray(settings.dealBars)) return null;

    if (root.dataset.selectedKachingDealId) {
      var trackedDeal = settings.dealBars.find(function (deal) {
        return deal.id === root.dataset.selectedKachingDealId;
      });
      if (trackedDeal) return trackedDeal;
    }

    var selectedDeal = null;
    var roots = getSearchRoots(root);
    settings.dealBars.some(function (deal) {
      var title = deal.title || '';
      var selector = [
        '[data-deal-bar-id="' + deal.id + '"]',
        '[deal-bar-id="' + deal.id + '"]',
        '[data-id="' + deal.id + '"]',
        '[id="' + deal.id + '"]'
      ].join(',');

      for (var i = 0; i < roots.length; i += 1) {
        var node = roots[i].querySelector(selector);
        if (node && isSelectedKachingNode(node)) {
          selectedDeal = deal;
          return true;
        }
      }

      return false;
    });

    return selectedDeal || settings.dealBars.find(function (deal) {
      return deal.id === settings.preselectedDealBarId;
    }) || settings.dealBars[0];
  }

  function initKachingSelectionTracking(root) {
    if (!root || root.dataset.vbKachingSelectionTracking === 'true') return;
    if (!root.querySelector('.vb-pdp-product__kaching')) return;

    root.dataset.vbKachingSelectionTracking = 'true';
    root.addEventListener('click', function (event) {
      var settings = getKachingDealSettings(root);
      if (!settings || !Array.isArray(settings.dealBars)) return;

      var path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
      for (var i = 0; i < path.length; i += 1) {
        var node = path[i];
        if (!node || !node.textContent) continue;

        var text = String(node.textContent).replace(/\s+/g, ' ').trim();
        if (!text || text.length > 600) continue;

        var clickedDeal = settings.dealBars.find(function (deal) {
          return deal.title && text.indexOf(deal.title) !== -1;
        });

        if (clickedDeal) {
          root.dataset.selectedKachingDealId = clickedDeal.id;
          break;
        }
      }
    }, true);
  }

  function getKachingBridgeContext(root) {
    if (!root || !root.querySelector('.vb-pdp-product__kaching')) return null;

    var settings = getKachingDealSettings(root);
    var selectedDeal = getSelectedKachingDeal(root, settings);
    if (!settings || !selectedDeal) return null;

    var productId = root.querySelector('kaching-bundle') && root.querySelector('kaching-bundle').getAttribute('product-id');

    return {
      id: root.dataset.kachingBundleId || 'yRTi',
      deal: settings.nanoId || settings.id,
      v: root.dataset.kachingPropertyVersion || settings.versionId,
      bid: selectedDeal.id,
      pp: productId ? Number(productId) : null,
      quantity: Number(selectedDeal.quantity || 1)
    };
  }

  function getUnlockedKachingGiftIds() {
    var root = getProductRoot();
    if (!root || !root.querySelector('.vb-pdp-product__kaching')) return null;

    var settings = getKachingDealSettings(root);
    var selectedDeal = getSelectedKachingDeal(root, settings);
    if (!settings || !selectedDeal || !Array.isArray(settings.dealBars)) return null;

    var selectedBarIndex = settings.dealBars.findIndex(function (deal) {
      return deal.id === selectedDeal.id;
    }) + 1;
    var gifts = settings.progressiveGifts && settings.progressiveGifts.gifts;
    if (!selectedBarIndex || !Array.isArray(gifts)) return null;

    return gifts
      .filter(function (gift) {
        if (!gift || gift.giftType !== 'product' || !gift.id || !gift.unlockAtBar) return false;
        return gift.unlockAtBarOnly ? gift.unlockAtBar === selectedBarIndex : gift.unlockAtBar <= selectedBarIndex;
      })
      .map(function (gift) {
        return gift.id;
      });
  }

  function applyKachingDealToMainItem(payload) {
    if (!payload || !Array.isArray(payload.items) || !payload.items[0]) return payload;

    var root = getProductRoot();
    var context = getKachingBridgeContext(root);
    if (!context) return payload;

    var item = payload.items[0];
    if (context.quantity > 0) item.quantity = context.quantity;

    item.properties = Object.assign({}, item.properties || {});
    if (!item.properties.__kaching_bundles && context.id && context.deal && context.v && context.bid) {
      item.properties.__kaching_bundles = JSON.stringify({
        deal: context.deal,
        pp: context.pp,
        main: true,
        v: context.v,
        id: context.id,
        bid: context.bid
      });
    }

    return payload;
  }

  function applySelectedBundleToMainItem(payload) {
    if (!payload || !Array.isArray(payload.items) || !payload.items[0]) return payload;

    var root = getProductRoot();
    var selectedBundle = getSelectedBundle(root);
    if (!selectedBundle) return payload;

    var qty = Number(selectedBundle.dataset.qty || 1);
    var variantId = Number(selectedBundle.dataset.variantId || 0);

    if (variantId) payload.items[0].id = variantId;
    if (qty > 0) payload.items[0].quantity = qty;

    return payload;
  }

  function getConfiguredGifts() {
    var root = getProductRoot();
    if (!root) return [];

    return Array.prototype.slice.call(root.querySelectorAll('[data-vb-product-gift]'))
      .map(function (gift) {
        return {
          id: Number(gift.dataset.variantId),
          quantity: Number(gift.dataset.qty || 1),
          kachingGiftId: gift.dataset.kachingGiftId || ''
        };
      })
      .filter(function (item) {
        return item.id && item.quantity > 0;
      });
  }

  function getKachingContext(payload) {
    if (!payload || !Array.isArray(payload.items)) return null;

    for (var i = 0; i < payload.items.length; i += 1) {
      var item = payload.items[i];
      var raw = item && item.properties && item.properties.__kaching_bundles;
      if (!raw) continue;

      try {
        var data = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (data && data.main) {
          return {
            id: data.id,
            deal: data.deal,
            v: data.v
          };
        }
      } catch (error) {
        // Ignore malformed app metadata.
      }
    }

    return null;
  }

  function buildGiftItems(gifts, payload) {
    var kachingContext = getKachingContext(payload);

    return gifts.map(function (gift) {
      var properties = {
        _vb_free_gift: 'true'
      };

      if (kachingContext && gift.kachingGiftId) {
        properties.__kaching_bundles = JSON.stringify({
          id: kachingContext.id,
          deal: kachingContext.deal,
          v: kachingContext.v,
          gift: gift.kachingGiftId
        });
      }

      return {
        id: gift.id,
        quantity: gift.quantity,
        properties: properties
      };
    });
  }

  function shouldAddGiftItems(payload) {
    if (!payload || !Array.isArray(payload.items) || !payload.items[0]) return false;
    return Number(payload.items[0].quantity || 1) > 1;
  }

  function cartPayloadFromFormData(formData) {
    var properties = {};

    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && value !== '') properties[match[1]] = value;
    });

    var mainItem = {
      id: Number(formData.get('id')),
      quantity: Number(formData.get('quantity') || 1)
    };

    if (Object.keys(properties).length) mainItem.properties = properties;

    var payload = {
      items: [mainItem]
    };
    var sections = formData.get('sections');
    var sectionsUrl = formData.get('sections_url');

    if (sections) payload.sections = String(sections).split(',');
    if (sectionsUrl) payload.sections_url = sectionsUrl;

    return payload;
  }

  function jsonCartAddInit(init, payload) {
    var headers = new Headers(init && init.headers ? init.headers : {});
    headers.set('Content-Type', 'application/json');
    headers.set('Accept', 'application/json');

    return Object.assign({}, init, {
      headers: headers,
      body: JSON.stringify(payload)
    });
  }

  function patchCartAddPayload(payload) {
    var gifts = getConfiguredGifts();
    if (payload && !Array.isArray(payload.items) && payload.id) {
      payload = {
        items: [{
          id: Number(payload.id),
          quantity: Number(payload.quantity || 1),
          properties: payload.properties
        }]
      };
    }

    if (!payload || !Array.isArray(payload.items)) return payload;

    payload = applySelectedBundleToMainItem(payload);
    payload = applyKachingDealToMainItem(payload);
    var unlockedKachingGiftIds = getUnlockedKachingGiftIds();
    if (unlockedKachingGiftIds) {
      gifts = gifts.filter(function (gift) {
        return gift.kachingGiftId && unlockedKachingGiftIds.indexOf(gift.kachingGiftId) !== -1;
      });
    }
    if (!gifts.length) return payload;
    if (!shouldAddGiftItems(payload)) return payload;

    var alreadyHasThemeGifts = payload.items.some(function (item) {
      return item.properties && item.properties._vb_free_gift === 'true';
    });
    if (alreadyHasThemeGifts) return payload;

    payload.items = payload.items.concat(buildGiftItems(gifts, payload));
    window.vbProductLastPatchedCartPayload = payload;
    return payload;
  }

  function installGiftFetchPatch() {
    if (window.vbProductGiftFetchPatchInstalled || typeof window.fetch !== 'function') return;
    window.vbProductGiftFetchPatchInstalled = true;

    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var isCartAdd = url && String(url).indexOf('/cart/add') !== -1;
      var nextInit = init;

      if (isCartAdd && init && typeof init.body === 'string') {
        try {
          var payload = JSON.parse(init.body);
          nextInit = Object.assign({}, init, {
            body: JSON.stringify(patchCartAddPayload(payload))
          });
        } catch (error) {
          // Non-JSON cart requests are handled by the standard product-form path.
        }
      } else if (isCartAdd && init && window.FormData && init.body instanceof FormData) {
        nextInit = jsonCartAddInit(init, patchCartAddPayload(cartPayloadFromFormData(init.body)));
      }

      return originalFetch.call(this, input, nextInit);
    };
  }

  function installGiftXhrPatch() {
    if (window.vbProductGiftXhrPatchInstalled || typeof window.XMLHttpRequest === 'undefined') return;
    window.vbProductGiftXhrPatchInstalled = true;

    var originalOpen = window.XMLHttpRequest.prototype.open;
    var originalSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function (method, url) {
      this._vbProductCartAddUrl = url;
      return originalOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function (body) {
      var url = this._vbProductCartAddUrl;
      var isCartAdd = url && String(url).indexOf('/cart/add') !== -1;
      var nextBody = body;

      if (isCartAdd && typeof body === 'string') {
        try {
          var payload = JSON.parse(body);
          nextBody = JSON.stringify(patchCartAddPayload(payload));
        } catch (error) {
          // Non-JSON cart requests are handled by the standard product-form path.
        }
      }

      return originalSend.call(this, nextBody);
    };
  }

  function initGiftAddToCart(root) {
    var productForm = root.querySelector('.vb-pdp-product__form[data-vb-product-add-gifts="true"]');
    if (!productForm) return;

    var form = productForm.querySelector('form');
    var submitButton = productForm.querySelector('[type="submit"]');
    var spinner = productForm.querySelector('.loading__spinner');
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (!form || form.dataset.vbGiftSubmitInit === 'true') return;

    form.dataset.vbGiftSubmitInit = 'true';
    form.addEventListener('submit', function (event) {
      var gifts = Array.prototype.slice.call(root.querySelectorAll('[data-vb-product-gift]'))
        .map(function (gift) {
          return {
            id: Number(gift.dataset.variantId),
            quantity: Number(gift.dataset.qty || 1),
            properties: {
              _vb_free_gift: 'true'
            }
          };
        })
        .filter(function (item) {
          return item.id && item.quantity > 0;
        });

      if (!gifts.length) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') return;
      if (submitButton) {
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      }
      if (spinner) spinner.classList.remove('hidden');

      var formData = new FormData(form);
      var selectedBundle = getSelectedBundle(root);
      var mainItem = {
        id: selectedBundle && selectedBundle.dataset.variantId ? Number(selectedBundle.dataset.variantId) : Number(formData.get('id')),
        quantity: selectedBundle && selectedBundle.dataset.qty ? Number(selectedBundle.dataset.qty) : Number(formData.get('quantity') || 1)
      };
      var body = { items: [mainItem].concat(gifts) };

      if (cart) {
        body.sections = cart.getSectionsToRender().map(function (section) { return section.id; });
        body.sections_url = window.location.pathname;
        cart.setActiveElement(document.activeElement);
      }

      var config = fetchConfig('javascript');
      config.body = JSON.stringify(body);

      fetch(window.routes.cart_add_url, config)
        .then(function (response) { return response.json(); })
        .then(function (response) {
          if (response.status) {
            console.error(response.description || response.message || response);
            return;
          }

          if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (window.PUB_SUB_EVENTS && window.publish) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'vb-pdp-product',
              productVariantId: formData.get('id'),
              cartData: response
            });
          }

          cart.renderContents(response);
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(function () {
          if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          }
          if (spinner) spinner.classList.add('hidden');
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        });
    }, true);
  }

  function initProduct(root) {
    if (!root || root.dataset.vbProductInit === 'true') return;
    root.dataset.vbProductInit = 'true';
    initBundles(root);
    initKachingSelectionTracking(root);
    initGiftAddToCart(root);
    waitForSwiper(function () {
      initGallery(root);
    });
  }

  function boot() {
    installGiftFetchPatch();
    installGiftXhrPatch();
    window.vbProductGiftDebug = {
      getConfiguredGifts: getConfiguredGifts
    };
    document.querySelectorAll('[data-vb-pdp-product]').forEach(initProduct);
  }

  installGiftFetchPatch();
  installGiftXhrPatch();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-vb-pdp-product]');
    if (root) {
      root.dataset.vbProductInit = 'false';
      initProduct(root);
    }
  });
})();
